import React, { useEffect } from 'react';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';

import FloatingButton from '../../../../components/FloatingButton';
import { appConfig } from '../../../../config/app';
import { CustomEvents } from '../../../../constants/analytics.constant';
import {
  incidentRoad,
  original_crash,
} from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import useLogEventInAnalytics from '../../../../hooks/useLogAnalyticsEvent';
import InjuredPersons from './InjuredPersons.component';
import InjuredPersonDocumentation from './InjuredPersonsDocumentation';
import InjuredPersonDocumentationPhotos from './InjuredPersonsDocumentationPhotos';
import OtherMaterialDamage from './OtherMaterialDamage.component';
import OtherVehicleDamage from './OtherVehicleDamageForm.component';
import OwnDamagePhotos from './OwnDamagePhotos.component';
import TypeOfOwnDamage from './TypeOfOwnDamage.component';

const TypeOfDamage = () => {
  const { nextStep, sinister_body, updateSinisterBody } =
    useSinisterDataContext();
  const { logEvent } = useLogEventInAnalytics();
  let crash: { [index: string]: any } = incidentRoad.crash;

  useEffect(() => {
    //TODO: fix this bad assignation
    crash = original_crash.crash;
  }, []);

  const ownDamageStep = {
    title: 'Tipo de daño propio',
    content: <TypeOfOwnDamage />,
    order: 2,
  };

  const ownDamagePhoto = {
    title: 'Fotografías de los daños',
    content: <OwnDamagePhotos />,
    order: 3,
  };

  const OtherVehicleDamageStep = {
    title: 'Daños a otro vehículo',
    content: <OtherVehicleDamage />,
    order: 4,
  };

  const InjuredPersonsStep = {
    title: 'Personas lesionadas',
    content: <InjuredPersons />,
    order: 5,
  };

  const InjuredPersonsDocumentationStep = {
    title: 'Documentación',
    content: <InjuredPersonDocumentation />,
    order: 6,
  };

  const InjuredPersonsDocumentationPhotosStep = {
    title: 'Subiendo documentación',
    content: <InjuredPersonDocumentationPhotos />,
    order: 7,
  };

  const OtherMaterialDamageStep = {
    title: 'Otros daños materiales a terceros',
    content: <OtherMaterialDamage />,
    order: 8,
  };

  const handleCheckboxChange = (event: any) => {
    crash = incidentRoad.crash;

    if (event.target.name === 'damage_in_my_vehicle') {
      if (
        !crash.find(
          (element: { title: any }) => element.title === ownDamageStep.title
        ) &&
        event.target.checked
      ) {
        crash.push(ownDamageStep);
        crash.push(ownDamagePhoto);
      } else {
        const key = crash.findIndex(
          (element: any) => element.title === ownDamageStep.title
        );
        crash.splice(key, 1);
        crash.splice(key, 1);
      }
    }

    if (event.target.name === 'damage_in_other_vehicle') {
      if (
        !crash.find(
          (element: { title: any }) =>
            element.title === OtherVehicleDamageStep.title
        ) &&
        event.target.checked
      ) {
        crash.push(OtherVehicleDamageStep);
      } else {
        const key = crash.findIndex(
          (element: any) => element.title === OtherVehicleDamageStep.title
        );
        crash.splice(key, 1);
      }
    }

    if (event.target.name === 'was_there_injured') {
      if (
        !crash.find(
          (element: { title: any }) =>
            element.title === InjuredPersonsStep.title ||
            element.title === InjuredPersonsDocumentationStep.title ||
            element.title === InjuredPersonsDocumentationPhotosStep.title
        ) &&
        event.target.checked
      ) {
        crash.push(InjuredPersonsStep);
        crash.push(InjuredPersonsDocumentationStep);
        crash.push(InjuredPersonsDocumentationPhotosStep);
      } else {
        const key = crash.findIndex(
          (element: any) => element.title === InjuredPersonsStep.title
        );
        crash.splice(key, 1);
        crash.splice(key, 1);
        crash.splice(key, 1);
      }
    }

    if (event.target.name === 'damage_material') {
      if (
        !crash.find(
          (element: { title: any }) =>
            element.title === OtherMaterialDamageStep.title
        ) &&
        event.target.checked
      ) {
        crash.push(OtherMaterialDamageStep);
      } else {
        const key = crash.findIndex(
          (element: any) => element.title === OtherMaterialDamageStep.title
        );
        crash.splice(key, 1);
      }
    }

    crash = crash.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));

    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });

    updateSinisterBody({
      crash: {
        ...sinister_body?.crash,
        additional_information: {
          ...state,
          [event.target.name]: event.target.checked,
        },
      },
    });
  };

  const [state, setState] = React.useState({
    damage_in_my_vehicle:
      sinister_body.crash?.additional_information?.damage_in_my_vehicle ||
      false,
    damage_in_other_vehicle:
      sinister_body.crash?.additional_information?.damage_in_other_vehicle ||
      false,
    was_there_injured:
      sinister_body.crash?.additional_information?.was_there_injured || false,
    damage_material:
      sinister_body.crash?.additional_information?.damage_material || false,
  });

  const {
    damage_in_my_vehicle,
    damage_in_other_vehicle,
    damage_material,
    was_there_injured,
  } = state;

  const isDisabled = () => {
    const check = Object.values(state).some((element) => element === true);
    return !check;
  };

  const handleNextStep = () => {
    logEvent(
      was_there_injured
        ? CustomEvents.COMPLAINTS_CRASH_INJURED
        : CustomEvents.COMPLAINTS_CRASH_NOT_INJURED,
      {
        app: appConfig?.NAME,
      }
    );
    nextStep();
  };

  return (
    <>
      <Grid container>
        <Grid container item lg={12}>
          <Box my={3}>
            <Typography
              variant="h6"
              color="textPrimary"
              style={{ fontFamily: 'Inter' }}
            >
              Indicanos otros detalles para completar tu denuncia
            </Typography>
          </Box>
        </Grid>

        <Grid container item lg={12}>
          <Box mr={2} my={2}>
            <FormControl component="fieldset">
              <FormGroup aria-label="position">
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={damage_in_my_vehicle}
                      onChange={handleCheckboxChange}
                      name="damage_in_my_vehicle"
                    />
                  }
                  label="Se produjeron daños en mi vehículo"
                />
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={damage_in_other_vehicle}
                        onChange={handleCheckboxChange}
                        name="damage_in_other_vehicle"
                      />
                    }
                    label="Se produjeron daños a otro vehículo"
                  />
                </Box>
                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={was_there_injured}
                        onChange={handleCheckboxChange}
                        name="was_there_injured"
                      />
                    }
                    label="Hubo personas lesionadas"
                  />
                  <Box ml={4}>
                    <Typography variant="subtitle1">
                      (Lesión, dolencia o molestia)
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={damage_material}
                        onChange={handleCheckboxChange}
                        name="damage_material"
                      />
                    }
                    label="Otros daños materiales a terceros"
                  />
                  <Box ml={4}>
                    <Typography variant="subtitle1">
                      (Casa, comercio, bicicleta, etc)
                    </Typography>
                  </Box>
                </Box>
              </FormGroup>
            </FormControl>
          </Box>
        </Grid>
        <Grid container item lg={12} />
        <Grid container justify="center">
          <Grid item xs={12} sm={6}>
            <FloatingButton onClick={handleNextStep} disabled={isDisabled()}>
              Continuar
            </FloatingButton>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default TypeOfDamage;
